import { render, staticRenderFns } from "./QuadroResumoRateios.vue?vue&type=template&id=df40891e"
import script from "./QuadroResumoRateios.vue?vue&type=script&lang=js"
export * from "./QuadroResumoRateios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports